/**
 * REST warranty-configuration endpoints — admin-only.
 *
 *   GET   /admin/warranty-config  — list per-product-type defaults
 *   PATCH /admin/warranty-config  — update a single product-type's duration
 *
 * Three product types:
 *   stair-light   — Stair Light (M8 family)   — starts at owner-claim
 *   ceiling-light — Ceiling Light (M8 family)  — starts at owner-claim
 *   cop-lop       — Lift (COP-LOP family)      — starts at seller registration
 *
 * Changing the duration affects only *future* devices; existing devices keep
 * their pre-computed warranty_expires_at so live warranties are not shifted.
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
import { Iso8601Schema } from '../common/timestamp.js';
// ── POST /profile/register-warranty ───────────────────────────────────────
export const RegisterWarrantyBody = z.object({
    serialNumber: z.string().min(1).max(64),
    billNumber: z.string().min(1).max(100),
});
export const RegisterWarrantyResponse = z.object({ id: UuidSchema });
export const WarrantyProductTypeSchema = z.enum(['stair-light', 'ceiling-light', 'cop-lop']);
export const WarrantyStartsFromSchema = z.enum(['activation', 'registration']);
export const WarrantyConfigEntrySchema = z.object({
    productType: WarrantyProductTypeSchema,
    durationMonths: z.number().int().min(1).max(240),
    startsFrom: WarrantyStartsFromSchema,
    updatedAt: Iso8601Schema,
});
export const WarrantyConfigListResponse = z.object({
    entries: z.array(WarrantyConfigEntrySchema),
});
export const WarrantyConfigUpdateBody = z.object({
    productType: WarrantyProductTypeSchema,
    durationMonths: z.number().int().min(1).max(240),
});
//# sourceMappingURL=warranty.js.map